export const SUB_ORDER_TYPE = {
    PRODUCT: "PRODUCT",
    TOURPACKAGE: "TOURPACKAGE",
    SERVICE: "SERVICE",
    SUBSCRIPTION: "SUBSCRIPTION",
}